//import { gql } from "@apollo/client";
import gql from "graphql-tag";

const ORGAN_DETAILS = gql`
  fragment OrganDetails on Organ {
    organname
    organshort
    organmunicipality
    organurl
    domain
    active
    system
  }
`;
const LINK_DETAILS = gql`
  fragment LinkDetails on Link {
    linkdatetime
    linktext
    linkdatetime
    linktext
    commentid
    initiativeid
    sectionid
    proposalid
    linktype
    linkref
    userid
  }
`;
const USER_DETAILS = gql`
  fragment UserDetails on User {
    name
    email
    address
    postnumber
    postoffice
    phone
    activated
    type
    datetime
    acceptedtermsofuse
    gender
    born
    municipality
    role
    secondarymunicipality
    secondarypostnumber
    secondaryaddress
    secondaryrole
    country
    locked
    code
  }
`;
const INITIATIVE_DETAILS = gql`
  fragment InitiativeDetails on Initiative {
    organid
    initiativetext
    initiativedatetime
    initiativeinfo
    initiativeaccepted
    active
  }
`;
const VOTING_DETAILS = gql`
  fragment VotingDetails on Voting {
    proposalid
    commentid
    sectionid
    userid
    initiativeid
    votedatetime
    voteinfo
  }
`;

const SECTION_DETAILS = gql`
  fragment SectionDetails on Section {
    caseid
    preparer
    header
    casetext
    proposalforadecision
    x
    y
    z
    address
    postnumber
    postoffice
    country
    attachments
    sectionmunicipality
    agendaid
    sectionurl
  }
`;
const MINUTESECTION_DETAILS = gql`
  fragment MinutesectionDetails on Minutesection {
    caseid
    preparer
    header
    casetext
    proposalforadecision
    x
    y
    z
    address
    postnumber
    postoffice
    country
    attachments
    sectionmunicipality
    agendaid
    sectionurl
  }
`;
const MINUT_DETAILS = gql`
  fragment MinutDetails on Minut {
    caseid
    preparer
    header
    casetext
    proposalforadecision
    decision
    x
    y
    z
    address
    postnumber
    postoffice
    country
    attachments
    minutmunicipality
    minutesid
    minuturl
  }
`;
const COMMENT_DETAILS = gql`
  fragment CommentDetails on Comment {
    commentdatetime
    commenttext
    user
    sectionid
  }
`;
const STRATEGYCOMMENT_DETAILS = gql`
  fragment StrategycommentDetails on Comment {
    commentdatetime
    commenttext
    userid
    sectionid
  }
`;
const MEETING_DETAILS = gql`
  fragment MeetingDetails on Meeting {
    meetingdatetime
    meetingtext
    organid
    meetingmunicipality
    agendaurl
  }
`;
const MINUTES_DETAILS = gql`
  fragment MinutesDetails on Minutes {
    minutesdatetime
    minutestext
    organid
    minutesmunicipality
    minutesurl
  }
`;
const PROPOSAL_DETAILS = gql`
  fragment ProposalDetails on Proposal {
    proposaldatetime
    commenttext
    sectionid
    userid
  }
`;

export const ALL_LINKS = gql`
  query {
    allLinks {
      linkdatetime
      linktext
      commentid
      initiativeid
      sectionid
      proposalid
      linktype
      linkref
      id
    }
  }
`;
export const ALL_STRATEGYCOMMENTS = gql`
  query {
    allStrategycomments {
      strategydatetime
      strategyclass
      strategytext
      municipality
      userid
      active
      id
    }
  }
`;
export const ALL_STRATEGYBUDGETS = gql`
  query {
    allStrategybudgets {
      strategydatetime
      target
      municipality
      amount
      userid
      active
      id
    }
  }
`;
export const ALL_STRATEGYFOCUSAREAS = gql`
  query {
    allStrategyfocusareas {
      strategydatetime
      weights
      weightclass
      municipality
      userid
      active
      id
    }
  }
`;
export const ALL_STRATEGYMAPS = gql`
  query {
    allStrategymaps {
      maptext
      x
      y
      strategydatetime
      municipality
      userid
      active
      id
    }
  }
`;
export const ALL_STRATEGYSWOTS = gql`
  query {
    allStrategyswots {
      strategydatetime
      swotclass
      swottext
      municipality
      userid
      active
      id
    }
  }
`;
export const ALL_VOTES = gql`
  query {
    allVotes {
      proposalid
      commentid
      sectionid
      linkid
      userid
      initiativeid
      votedatetime
      voteinfo
      id
    }
  }
`;
export const ALL_USERS = gql`
  query {
    allUsers {
      name
      email
      address
      postnumber
      postoffice
      phone
      activated
      type
      datetime
      acceptedtermsofuse
      gender
      born
      municipality
      role
      secondarymunicipality
      secondarypostnumber
      secondaryaddress
      secondaryrole
      country
      locked
      passwordhash
      code
      id
    }
  }
`;
export const ALL_MUNICONFIG = gql`
  query {
    allMuniconfigs {
      datetime
      name
      votefilter
      strategyfilter
      initiativefilter
      active
      login
      text
      roles
      strategytext
      strategycomments
      strategyswot
      strategyfocusareas
      strategymap
      strategycommentcategories
      strategyfocusareacategories
      strategybudget
      id
    }
  }
`;
export const ALL_INITIATIVES = gql`
  query {
    allInitiatives {
      organid
      initiativetext
      initiativedatetime
      initiativeinfo
      initiativeaccepted
      active
      id
    }
  }
`;

export const ALL_ORGANS = gql`
  query {
    allOrgans {
      organname
      organshort
      organmunicipality
      organurl
      active
      domain
      system
      id
    }
  }
`;
export const ALL_MEETINGS = gql`
  query {
    allMeetings {
      meetingtext
      meetingdatetime
      organid
      meetingmunicipality
      agendaurl
      id
    }
  }
`;
export const ALL_MINUTES = gql`
  query {
    allMinutes {
      minutestext
      minutesdatetime
      organid
      minutesmunicipality
      minutesurl
      id
    }
  }
`;
export const ALL_MUNICIPALITIES = gql`
  query {
    allMunicipalities {
      organmunicipality
    }
  }
`;

export const ALL_SECTIONS = gql`
  query {
    allSections {
      caseid
      preparer
      header
      casetext
      proposalforadecision
      x
      y
      z
      address
      postnumber
      postoffice
      country
      attachments
      sectionmunicipality
      agendaid
      sectionurl
      id
    }
  }
`;
export const ALL_MINUT = gql`
  query {
    allMinut {
      caseid
      preparer
      header
      casetext
      proposalforadecision
      decision
      x
      y
      z
      address
      postnumber
      postoffice
      country
      attachments
      minutmunicipality
      minutesid
      minuturl
      id
    }
  }
`;
export const FIND_ORGAN = gql`
  query findOrganByName($nameToSearch: String!) {
    findOrgan(organname: $nameToSearch) {
      organname
      organshort
      organmunicipality
      organurl
      id
    }
  }
`;
export const FIND_LINK = gql`
  query findLinkByID($IDToSearch: String!) {
    findLink(id: $IDToSearch) {
      linkdatetime
      linktext
      linkdatetime
      linktext
      commentid
      sectionid
      initiativeid
      proposalid
      linktype
      linkref
      userid
      id
    }
  }
`;

export const FIND_USER = gql`
  query findUserByEmail($email: String!) {
    findUser(email: $email) {
      name
      email
      address
      postnumber
      postoffice
      phone
      activated
      type
      datetime
      acceptedtermsofuse
      gender
      born
      municipality
      role
      secondarymunicipality
      secondarypostnumber
      secondaryaddress
      secondaryrole
      country
      locked
      code
      id
    }
  }
`;
export const FIND_MUNICONFIG = gql`
  query findMuniconfig($municipality: String!) {
    findMuniconfig(municipality: $municipality) {
      datetime
      name
      votefilter
      strategyfilter
      initiativefilter
      active
      login
      text
      roles
      strategytext
      strategycomments
      strategyswot
      strategyfocusareas
      strategymap
      strategycommentcategories
      strategyfocusareacategories
      strategybudget
      id
    }
  }
`;

export const FIND_INITIATIVE = gql`
  query findInitiativeByID($idToSearch: String!) {
    findInitiative(id: $idToSearch) {
      organid
      initiativetext
      initiativedatetime
      initiativeinfo
      initiativeaccepted
      active
      userid
      id
    }
  }
`;

export const FIND_VOTE = gql`
  query findVoteByID($IDToSearch: String!) {
    findVote(id: $IDToSearch) {
      proposalid
      commentid
      sectionid
      initiativeid
      linkid
      userid
      votedatetime
      voteinfo
      id
    }
  }
`;

export const FIND_COMMENT = gql`
  query findCommentByDatetime($datetimeToSearch: String!) {
    findComment(commentdatetime: $datetimeToSearch) {
      commentdatetime
      commenttext
      sectionid
      id
    }
  }
`;
export const GET_USERPASSCODE = gql`
  query getUserpasscode($email: String!) {
    getUserpasscode(email: $email) {
      message
    }
  }
`;
export const FIND_SECTION = gql`
  query findSection($id: String!) {
    findSection(id: $id) {
      caseid
      preparer
      header
      casetext
      proposalforadecision
      x
      y
      z
      address
      postnumber
      postoffice
      country
      attachments
      sectionmunicipality
      agendaid
      sectionurl
      id
    }
  }
`;
export const FIND_MINUT = gql`
  query findMinutByID($IDToSearch: String!) {
    findMinut(id: $IDToSearch) {
      caseid
      preparer
      header
      casetext
      proposalforadecision
      decision
      x
      y
      z
      address
      postnumber
      postoffice
      country
      attachments
      minutmunicipality
      minutesid
      minuturl
      id
    }
  }
`;

export const FIND_MEETING = gql`
  query findMeetingByDatetime($datetimeToSearch: String!) {
    findMeeting(meetingdatetime: $datetimeToSearch) {
      meetingtext
      meetingdatetime
      organid
      meetingmunicipality
      agendaurl
      id
    }
  }
`;
export const FIND_MINUTES = gql`
  query findMinutesByDatetime($datetimeToSearch: String!) {
    findMinutes(minutesdatetime: $datetimeToSearch) {
      minutestext
      minutesdatetime
      organid
      minutesmunicipality
      minutesurl
      id
    }
  }
`;
export const FIND_PROPOSAL = gql`
  query findProposalByDatetime($datetimeToSearch: String!) {
    findProposal(proposaldatetime: $datetimeToSearch) {
      proposaldatetime
      proposaltext
      sectionid
      userid
      id
    }
  }
`;
export const FIND_MUNICIPAL = gql`
  query findMunicipalByName($nameToSearch: String!) {
    findMunicipal(municipalname: $nameToSearch) {
      name
      id
    }
  }
`;

export const CREATE_VOTING = gql`
  mutation createVoting(
    $initiativeid: String
    $strategycommentid: String
    $strategyswotid: String
    $strategybudgetid: String
    $strategyfocusareaid: String
    $strategymapid: String
    $linkid: String
    $sectionid: String
    $proposalid: String
    $commentid: String
    $userid: String
    $municipality: String
    $votedatetime: String!
    $voteinfo: String
  ) {
    addVote(
      strategycommentid: $strategycommentid
      strategyswotid: $strategyswotid
      strategybudgetid: $strategybudgetid
      strategyfocusareaid: $strategyfocusareaid
      strategymapid: $strategymapid
      proposalid: $proposalid
      commentid: $commentid
      userid: $userid
      municipality: $municipality
      sectionid: $sectionid
      linkid: $linkid
      votedatetime: $votedatetime
      voteinfo: $voteinfo
      initiativeid: $initiativeid
    ) {
      strategycommentid
      strategyswotid
      strategybudgetid
      strategyfocusareaid
      strategymapid
      proposalid
      commentid
      userid
      sectionid
      linkid
      votedatetime
      voteinfo
      initiativeid
      municipality
      id
    }
  }
`;
export const CREATE_USER = gql`
  mutation addUser(
    $name: String!
    $email: String!
    $code: String
    $locked: Boolean
    $passwordhash: String!
    $address: String
    $gender: String
    $born: String
    $municipality: String
    $role: String
    $secondarymunicipality: String
    $secondarypostnumber: String
    $secondaryaddress: String
    $secondaryrole: String
    $country: String
    $acceptedtermsofuse: String
    $postnumber: String!
    $postoffice: String!
    $phone: String
    $activated: Boolean
    $type: String
    $datetime: String
  ) {
    addUser(
      name: $name
      email: $email
      passwordhash: $passwordhash
      address: $address
      postnumber: $postnumber
      postoffice: $postoffice
      phone: $phone
      activated: $activated
      type: $type
      datetime: $datetime
      acceptedtermsofuse: $acceptedtermsofuse
      born: $born
      gender: $gender
      municipality: $municipality
      role: $role
      secondarymunicipality: $secondarymunicipality
      secondarypostnumber: $secondarypostnumber
      secondaryaddress: $secondaryaddress
      secondaryrole: $secondaryrole
      country: $country
      locked: $locked
      code: $code
    ) {
      name
      email
      address
      postnumber
      postoffice
      phone
      activated
      type
      datetime
      acceptedtermsofuse
      born
      municipality
      secondarymunicipality
      secondarypostnumber
      secondaryaddress
      secondaryrole
      country
      gender
      locked
      code
      id
    }
  }
`;
export const CREATE_MUNICONFIG = gql`
  mutation addMuniconfig(
    $datetime: String!
    $name: String!
    $votefilter: Boolean
    $strategyfilter: Boolean
    $initiativefilter: Boolean
    $active: Boolean
    $login: Boolean
    $text: String
    $roles: String
    $strategytext: String
    $strategycomments: Boolean
    $strategyswot: Boolean
    $strategyfocusareas: Boolean
    $strategymap: Boolean
    $strategycommentcategories: String
    $strategyfocusareacategories: String
    $strategybudget: Boolean
  ) {
    addMuniconfig(
      datetime: $datetime
      name: $name
      votefilter: $votefilter
      strategyfilter: $strategyfilter
      initiativefilter: $initiativefilter
      active: $active
      login: $login
      text: $text
      roles: $roles
      strategytext: $strategytext
      strategycomments: $strategycomments
      strategyswot: $strategyswot
      strategyfocusareas: $strategyfocusareas
      strategymap: $strategymap
      strategycommentcategories: $strategycommentcategories
      strategyfocusareacategories: $strategyfocusareacategories
      strategybudget: $strategybudget
    ) {
      datetime
      name
      votefilter
      strategyfilter
      initiativefilter
      active
      login
      text
      roles
      strategytext
      strategycomments
      strategyswot
      strategyfocusareas
      strategymap
      strategycommentcategories
      strategyfocusareacategories
      strategybudget
      id
    }
  }
`;
export const CREATE_INITIATIVE = gql`
  mutation createInitiative(
    $organid: String
    $initiativetext: String!
    $initiativedatetime: String!
    $municipality: String!
    $initiativeinfo: String
    $initiativeaccepted: Boolean
    $active: Boolean
    $userid: String
  ) {
    addInitiative(
      organid: $organid
      initiativetext: $initiativetext
      initiativedatetime: $initiativedatetime
      municipality: $municipality
      initiativeinfo: $initiativeinfo
      initiativeaccepted: $initiativeaccepted
      active: $active
      userid: $userid
    ) {
      organid
      initiativetext
      initiativedatetime
      initiativeinfo
      initiativeaccepted
      municipality
      active
      userid
      id
    }
  }
`;

export const CREATE_ORGAN = gql`
  mutation createOrgan(
    $organname: String!
    $organshort: String!
    $organmunicipality: String!
    $organurl: String
    $system: String
    $domain: String
  ) {
    addOrgan(
      organname: $organname
      organshort: $organshort
      organmunicipality: $organmunicipality
      organurl: $organurl
      system: $system
      domain: $domain
    ) {
      organname
      organshort
      organmunicipality
      organurl
      system
      domain
      id
    }
  }
`;

export const CREATE_COMMENT = gql`
  mutation createComment(
    $commenttext: String!
    $commentdatetime: String!
    $sectionid: String
    $userid: String!
  ) {
    addComment(
      commenttext: $commenttext
      commentdatetime: $commentdatetime
      sectionid: $sectionid
      userid: $userid
    ) {
      commenttext
      commentdatetime
      sectionid
      userid
      id
    }
  }
`;
export const CREATE_STRATEGYCOMMENT = gql`
  mutation createStrategycomment(
    $strategytext: String!
    $strategydatetime: String!
    $strategyclass: String!
    $municipality: String!
    $userid: String!
    $info: String
  ) {
    addStrategycomment(
      strategytext: $strategytext
      strategydatetime: $strategydatetime
      strategyclass: $strategyclass
      municipality: $municipality
      userid: $userid
      info: $info
    ) {
      strategytext
      strategydatetime
      strategyclass
      municipality
      userid
      id
    }
  }
`;
export const CREATE_STRATEGYBUDGET = gql`
  mutation createStrategybudget(
    $amount: Int!
    $target: String!
    $strategydatetime: String!
    $municipality: String!
    $userid: String
    $active: Boolean
    $info: String
  ) {
    addStrategybudget(
      amount: $amount
      target: $target
      strategydatetime: $strategydatetime
      municipality: $municipality
      userid: $userid
      active: $active
      info: $info
    ) {
      amount
      target
      strategydatetime
      municipality
      userid
      active
      id
    }
  }
`;
export const CREATE_STRATEGYFOCUSAREAS = gql`
  mutation createStrategyfocusareas(
    $weights: [Int!]
    $weightclass: [String!]
    $strategydatetime: String!
    $municipality: String!
    $userid: String!
    $active: Boolean
    $info: String
  ) {
    addStrategyfocusareas(
      weights: $weights
      weightclass: $weightclass
      strategydatetime: $strategydatetime
      municipality: $municipality
      userid: $userid
      active: $active
      info: $info
    ) {
      weights
      weightclass
      strategydatetime
      municipality
      userid
      active
    }
  }
`;
export const CREATE_STRATEGYSWOT = gql`
  mutation createStrategyswot(
    $swottext: String!
    $swotclass: String!
    $strategydatetime: String!
    $municipality: String!
    $userid: String
    $info: String
    $active: Boolean
  ) {
    addStrategyswot(
      swottext: $swottext
      swotclass: $swotclass
      strategydatetime: $strategydatetime
      municipality: $municipality
      userid: $userid
      active: $active
      info: $info
    ) {
      swottext
      swotclass
      strategydatetime
      municipality
      userid
      active
      id
    }
  }
`;
export const CREATE_STRATEGYMAP = gql`
  mutation createStrategymap(
    $maptext: String!
    $strategydatetime: String!
    $x: Float!
    $y: Float!
    $municipality: String!
    $userid: String!
    $info: String
    $active: Boolean
  ) {
    addStrategymap(
      maptext: $maptext
      strategydatetime: $strategydatetime
      x: $x
      y: $y
      municipality: $municipality
      userid: $userid
      info: $info
      active: $active
    ) {
      maptext
      strategydatetime
      x
      y
      municipality
      userid
      active
      id
    }
  }
`;

export const CREATE_LINK = gql`
  mutation createLink(
    $sectionid: String!
    $linktext: String!
    $linkdatetime: String!
    $initiativeid: String
    $linktype: String
    $linkref: String!
    $proposalid: String
    $commentid: String
  ) {
    addLink(
      linktext: $linktext
      linkdatetime: $linkdatetime
      commentid: $commentid
      sectionid: $sectionid
      initiativeid: $initiativeid
      proposalid: $proposalid
      linktype: $linktype
      linkref: $linkref
    ) {
      linktext
      linkdatetime
      commentid
      sectionid
      initiativeid
      proposalid
      linktype
      linkref
      id
    }
  }
`;

export const CREATE_SECTION = gql`
  mutation createSection(
    $caseid: String
    $header: String!
    $preparer: String!
    $sectionurl: String
    $casetext: String!
    $proposalforadecision: String!
    $x: String
    $y: String
    $z: String
    $address: String
    $postnumber: String
    $postoffice: String
    $country: String
    $attachments: String
    $sectionmunicipality: String
    $agendaid: String
  ) {
    addSection(
      caseid: $caseid
      preparer: $preparer
      header: $header
      casetext: $casetext
      proposalforadecision: $proposalforadecision
      x: $x
      y: $y
      z: $z
      address: $address
      postnumber: $postnumber
      postoffice: $postoffice
      country: $country
      attachments: $attachments
      sectionmunicipality: $sectionmunicipality
      agendaid: $agendaid
      sectionurl: $sectionurl
    ) {
      caseid
      preparer
      casetext
      proposalforadecision
      x
      y
      z
      address
      postnumber
      postoffice
      country
      attachments
      sectionmunicipality
      agendaid
      sectionurl
      id
    }
  }
`;
export const CREATE_MEETING = gql`
  mutation createMeeting(
    $meetingtext: String!
    $agendaurl: String
    $meetingdatetime: String!
    $organid: String!
    $meetingmunicipality: String!
  ) {
    addMeeting(
      meetingtext: $meetingtext
      meetingdatetime: $meetingdatetime
      organid: $organid
      meetingmunicipality: $meetingmunicipality
      agendaurl: $agendaurl
    ) {
      meetingtext
      meetingdatetime
      organid
      meetingmunicipality
      agendaurl
      id
    }
  }
`;
export const CREATE_MINUT = gql`
  mutation createMinut(
    $caseid: String
    $header: String!
    $preparer: String
    $minuturl: String
    $casetext: String
    $proposalforadecision: String
    $decision: String
    $x: String
    $y: String
    $z: String
    $address: String
    $postnumber: String
    $postoffice: String
    $country: String
    $attachments: String
    $minutmunicipality: String
    $minutesid: String
  ) {
    addMinut(
      caseid: $caseid
      preparer: $preparer
      header: $header
      casetext: $casetext
      proposalforadecision: $proposalforadecision
      decision: $decision
      x: $x
      y: $y
      z: $z
      address: $address
      postnumber: $postnumber
      postoffice: $postoffice
      country: $country
      attachments: $attachments
      minutmunicipality: $minutmunicipality
      minutesid: $minutesid
      minuturl: $minuturl
    ) {
      caseid
      preparer
      casetext
      proposalforadecision
      decision
      x
      y
      z
      address
      postnumber
      postoffice
      country
      attachments
      minutmunicipality
      minutesid
      minuturl
      id
    }
  }
`;
export const CREATE_MINUTES = gql`
  mutation createMinutes(
    $minutestext: String
    $minutesurl: String
    $minutesdatetime: String
    $organid: String
    $minutesmunicipality: String
  ) {
    addMinutes(
      minutestext: $minutestext
      minutesdatetime: $minutesdatetime
      organid: $organid
      minutesmunicipality: $minutesmunicipality
      minutesurl: $minutesurl
    ) {
      minutestext
      minutesdatetime
      organid
      minutesmunicipality
      minutesurl
      id
    }
  }
`;
export const CREATE_PROPOSAL = gql`
  mutation createProposal(
    $proposaltext: String!
    $proposaldatetime: String!
    $sectionid: String
    $userid: String!
  ) {
    addProposal(
      proposaltext: $proposaltext
      proposaldatetime: $proposaldatetime
      sectionid: $sectionid
      userid: $userid
    ) {
      proposaltext
      proposaldatetime
      sectionid
      userid
      id
    }
  }
`;
export const CREATE_PERSON = gql`
  mutation createPerson($name: String!, $street: String!, $city: String!, $phone: String) {
    addPerson(name: $name, street: $street, city: $city, phone: $phone) {
      name
      phone
      id
      street
      city
    }
  }
`;
export const ALL_PERSONS = gql`
  query {
    allPersons {
      name
      phone
      id
    }
  }
`;
export const ALL_COMMENTS = gql`
  query {
    allComments {
      commenttext
      commentdatetime
      sectionid
      id
    }
  }
`;

export const ALL_PROPOSALS = gql`
  query {
    allProposals {
      proposaltext
      proposaldatetime
      sectionid
      userid
      id
    }
  }
`;

export const GET_SCRAPING = gql`
  query getScraping($url: String!, $system: String) {
    getScraping(url: $url, system: $system) {
      message
    }
  }
`;
export const GET_RAG = gql`
  query getRag($text: String!, $model: Int, $count: Int) {
    getRag(text: $text, model: $model, count: $count) {
      message
    }
  }
`;
export const GET_SCRAPINGPOST = gql`
  query getScrapingpost($url: String!, $system: String) {
    getScrapingpost(url: $url, system: $system) {
      message
    }
  }
`;
export const GET_SCRAPINGPDF = gql`
  query getScrapingpdf($url: String!, $system: String) {
    getScrapingpdf(url: $url, system: $system) {
      message
    }
  }
`;
export const GET_PIC = gql`
  query getPic($url: String!) {
    getPic(url: $url) {
      message
    }
  }
`;
export const EDIT_MEETING = gql`
  mutation editMeeting($meetingdatetime: String!, $meetingtext: String!) {
    editMeeting(meetingdatetime: $meetingdatetime, meetingtext: $meetingtext) {
      meetingdatetime
      meetingtext
      meetingmunicipality
      agendaurl
      id
    }
  }
`;
export const EDIT_MINUTES = gql`
  mutation editMinutes($minutesdatetime: String, $minutestext: String) {
    editMinutes(minutesdatetime: $minutesdatetime, minutestext: $minutestext) {
      minutesdatetime
      minutestext
      minutesmunicipality
      minutesurl
      id
    }
  }
`;
export const EDIT_USER = gql`
  mutation editUser(
    $name: String!
    $email: String!
    $code: String
    $locked: Boolean
    $passwordhash: String!
    $address: String
    $gender: String
    $born: String
    $municipality: String
    $role: String
    $secondarymunicipality: String
    $secondarypostnumber: String
    $secondaryaddress: String
    $secondaryrole: String
    $country: String
    $postnumber: String!
    $postoffice: String!
    $phone: String
    $activated: Boolean
    $type: String
    $datetime: String
  ) {
    editUser(
      name: $name
      email: $email
      passwordhash: $passwordhash
      address: $address
      postnumber: $postnumber
      postoffice: $postoffice
      phone: $phone
      activated: $activated
      type: $type
      datetime: $datetime
      born: $born
      gender: $gender
      municipality: $municipality
      role: $role
      secondarymunicipality: $secondarymunicipality
      secondarypostnumber: $secondarypostnumber
      secondaryaddress: $secondaryaddress
      secondaryrole: $secondaryrole
      country: $country
      locked: $locked
      code: $code
    ) {
      name
      email
      address
      postnumber
      postoffice
      phone
      activated
      type
      datetime
      born
      municipality
      country
      gender
      locked
      code
      id
    }
  }
`;

export const EDIT_MUNICONFIG = gql`
  mutation editMuniconfig(
    $datetime: String!
    $name: String!
    $votefilter: Boolean
    $strategyfilter: Boolean
    $initiativefilter: Boolean
    $active: Boolean
    $login: Boolean
    $text: String
    $roles: String
    $strategytext: String
    $strategycomments: Boolean
    $strategyswot: Boolean
    $strategyfocusareas: Boolean
    $strategymap: Boolean
    $strategycommentcategories: String
    $strategyfocusareacategories: String
    $strategybudget: Boolean
  ) {
    editMuniconfig(
      datetime: $datetime
      name: $name
      votefilter: $votefilter
      strategyfilter: $strategyfilter
      initiativefilter: $initiativefilter
      active: $active
      login: $login
      text: $text
      roles: $roles
      strategytext: $strategytext
      strategycomments: $strategycomments
      strategyswot: $strategyswot
      strategyfocusareas: $strategyfocusareas
      strategymap: $strategymap
      strategycommentcategories: $strategycommentcategories
      strategyfocusareacategories: $strategyfocusareacategories
      strategybudget: $strategybudget
    ) {
      datetime
      name
      votefilter
      strategyfilter
      initiativefilter
      active
      login
      text
      strategytext
      strategycomments
      strategyswot
      strategyfocusareas
      strategymap
      strategycommentcategories
      strategyfocusareacategories
      strategybudget
      id
    }
  }
`;
export const ACTIVATE_USER = gql`
  mutation activateUser($activated: Boolean!, $email: String!, $acceptedtermsofuse: String) {
    activateUser(activated: $activated, email: $email, acceptedtermsofuse: $acceptedtermsofuse) {
      email
      activated
      id
    }
  }
`;
export const LOCK_USER = gql`
  mutation lockUser($locked: Boolean!, $email: String!) {
    lockUser(locked: $locked, email: $email) {
      email
      locked
      id
    }
  }
`;
export const LOCK_COMMENT = gql`
  mutation lockComment($active: Boolean!, $id: String!) {
    lockComment(active: $active, id: $id) {
      active
      id
    }
  }
`;
export const LOCK_INITIATIVE = gql`
  mutation lockInitiative($active: Boolean!, $id: String!) {
    lockInitiative(active: $active, id: $id) {
      active
      id
    }
  }
`;
export const LOCK_PROPOSAL = gql`
  mutation lockProposal($active: Boolean!, $id: String!) {
    lockProposal(active: $active, id: $id) {
      active
      id
    }
  }
`;
export const LOCK_MEETING = gql`
  mutation lockMeeting($active: Boolean!, $id: String!) {
    lockMeeting(active: $active, id: $id) {
      active
      id
    }
  }
`;
export const LOCK_SECTION = gql`
  mutation lockSection($active: Boolean!, $id: String!) {
    lockSection(active: $active, id: $id) {
      active
      id
    }
  }
`;
export const LOCK_STRATEGYCOMMENT = gql`
  mutation lockStrategycomment($active: Boolean!, $id: String!) {
    lockStrategycomment(active: $active, id: $id) {
      active
      id
    }
  }
`;
export const LOCK_STRATEGYBUDGET = gql`
  mutation lockStrategybudget($active: Boolean!, $id: String!) {
    lockStrategybudget(active: $active, id: $id) {
      active
      id
    }
  }
`;
export const LOCK_STRATEGYFOCUSAREA = gql`
  mutation lockStrategyfocusarea($active: Boolean!, $id: String!) {
    lockStrategyfocusarea(active: $active, id: $id) {
      active
      id
    }
  }
`;
export const LOCK_STRATEGYSWOT = gql`
  mutation lockStrategyswot($active: Boolean!, $id: String!) {
    lockStrategyswot(active: $active, id: $id) {
      active
      id
    }
  }
`;
export const LOCK_STRATEGYMAP = gql`
  mutation lockStrategymap($active: Boolean!, $id: String!) {
    lockStrategymap(active: $active, id: $id) {
      active
      id
    }
  }
`;
export const LOCK_MINUTES = gql`
  mutation lockMinutes($active: Boolean!, $id: String!) {
    lockMinutes(active: $active, id: $id) {
      active
      id
    }
  }
`;
export const LOCK_MINUT = gql`
  mutation lockMinut($active: Boolean!, $id: String!) {
    lockMinut(active: $active, id: $id) {
      active
      id
    }
  }
`;
export const LOCK_ORGAN = gql`
  mutation lockOrgan($active: Boolean!, $id: String!) {
    lockOrgan(active: $active, id: $id) {
      active
      id
    }
  }
`;
export const LOCK_LINK = gql`
  mutation lockLink($active: Boolean!, $id: String!) {
    lockLink(active: $active, id: $id) {
      active
      id
    }
  }
`;

export const EDIT_PASSWORD = gql`
  mutation editPassword($email: String!, $passwordhash: String!) {
    editPassword(email: $email, passwordhash: $passwordhash) {
      email
      id
    }
  }
`;
export const SAVE_CODE = gql`
  mutation saveCode($email: String!, $code: String!) {
    saveCode(email: $email, code: $code) {
      message
    }
  }
`;
export const EDIT_VOTE = gql`
  mutation editVote(
    $proposalid: String
    $sectionid: String
    $commentid: String
    $userid: String
    $votedatetime: String!
    $voteinfo: String
    $initiativeid: String
  ) {
    editVote(
      proposalid: $proposalid
      sectionid: $sectionid
      commentid: $commentid
      userid: $userid
      votedatetime: $votedatetime
      voteinfo: $voteinfo
      initiativeid: $initiativeid
    ) {
      proposalid
      commentid
      sectionid
      userid
      initiativeid
      votedatetime
      voteinfo
      id
    }
  }
`;

export const EDIT_INITIATIVE = gql`
  mutation editInitiative(
    $organid: String
    $initiativetext: String
    $initiativedatetime: String
    $initiativeinfo: String
    $initiativeaccepted: String!
    $active: String
  ) {
    editInitiative(
      organid: $organid
      initiativetext: $initiativetext
      initiativedatetime: $initiativedatetime
      initiativeinfo: $initiativeinfo
      initiativeaccepted: $initiativeaccepted
      active: $active
    )
  }
`;

export const EDIT_ORGAN = gql`
  mutation editOrgan(
    $organname: String!
    $organshort: String!
    $organmunicipality: String!
    $organurl: String
    $system: String
    $active: Boolean
    $domain: String
  ) {
    editOrgan(
      organname: $organname
      organshort: $organshort
      organmunicipality: $organmunicipality
      organurl: $organurl
      system: $system
      domain: $domain
      active: $active
    ) {
      organname
      organshort
      organmunicipality
      organurl
      system
      domain
      active
      id
    }
  }
`;

export const EDIT_SECTION = gql`
  mutation editSection(
    $caseid: String
    $header: String!
    $preparer: String!
    $sectionurl: String
    $casetext: String!
    $proposalforadecision: String!
    $x: String
    $y: String
    $z: String
    $address: String
    $postnumber: String
    $postoffice: String
    $country: String
    $attachments: String
    $sectionmunicipality: String
    $agendaid: String
  ) {
    editSection(
      caseid: $caseid
      header: $header
      preparer: $preparer
      sectionurl: $sectionurl
      casetext: $casetext
      proposalforadecision: $proposalforadecision
      x: $x
      y: $y
      z: $z
      address: $address
      postnumber: $postnumber
      postoffice: $postoffice
      country: $country
      attachments: $attachments
      sectionmunicipality: $sectionmunicipality
      agendaid: $agendaid
    ) {
      caseid
      preparer
      header
      casetext
      proposalforadecision
      x
      y
      z
      address
      postnumber
      postoffice
      country
      attachments
      sectionmunicipality
      agendaid
      sectionurl
      id
    }
  }
`;
export const EDIT_MINUT = gql`
  mutation editMinut(
    $caseid: String
    $header: String!
    $preparer: String!
    $sectionurl: String
    $casetext: String
    $proposalforadecision: String
    $decision: String
    $x: String
    $y: String
    $z: String
    $address: String
    $postnumber: String
    $postoffice: String
    $country: String
    $attachments: String
    $minutmunicipality: String
    $minutesid: String
  ) {
    editMinut(
      caseid: $caseid
      header: $header
      preparer: $preparer
      minuturl: $minuturl
      casetext: $casetext
      proposalforadecision: $proposalforadecision
      decision: $decision
      x: $x
      y: $y
      z: $z
      address: $address
      postnumber: $postnumber
      postoffice: $postoffice
      country: $country
      attachments: $attachments
      minutmunicipality: $minutmunicipality
      minutesid: $minutesid
    ) {
      caseid
      preparer
      header
      casetext
      proposalforadecision
      decision
      x
      y
      z
      address
      postnumber
      postoffice
      country
      attachments
      minutmunicipality
      minutesid
      minuturl
      id
    }
  }
`;
export const DELETE_USER = gql`
  mutation deleteUser($id: String!) {
    deleteUser(id: $id) {
      name
    }
  }
`;
export const DELETE_MUNICONFIG = gql`
  mutation deleteMuniconfig($id: String!) {
    deleteMuniconfig(id: $id) {
      name
    }
  }
`;
export const DELETE_ORGAN = gql`
  mutation deleteOrgan($id: String!) {
    deleteOrgan(id: $id) {
      organname
    }
  }
`;
export const DELETE_COMMENT = gql`
  mutation deleteComment($id: String!) {
    deleteComment(id: $id) {
      commenttext
    }
  }
`;
export const DELETE_LINK = gql`
  mutation deleteLink($id: String!) {
    deleteLink(id: $id) {
      linktext
    }
  }
`;
export const DELETE_INITIATIVE = gql`
  mutation deleteInitiative($id: String!) {
    deleteInitiative(id: $id) {
      text
    }
  }
`;
export const DELETE_PROPOSAL = gql`
  mutation deleteProposal($id: String!) {
    deleteProposal(id: $id) {
      text
    }
  }
`;
export const DELETE_SECTION = gql`
  mutation deleteSection($id: String!) {
    deleteSection(id: $id) {
      casetext
    }
  }
`;
export const DELETE_MEETING = gql`
  mutation deleteMeeting($id: String!) {
    deleteMeeting(id: $id) {
      meetingtext
    }
  }
`;
export const DELETE_STRATEGYCOMMENT = gql`
  mutation deleteStrategycomment($id: String!) {
    deleteStrategycomment(id: $id) {
      id
    }
  }
`;
export const DELETE_STRATEGYBUDGET = gql`
  mutation deleteStrategybudget($id: String!) {
    deleteStrategybudget(id: $id) {
      id
    }
  }
`;
export const DELETE_STRATEGYFOCUSAREAS = gql`
  mutation deleteStrategyfocusareas($id: String!) {
    deleteStrategyfocusareas(id: $id) {
      id
    }
  }
`;
export const DELETE_STRATEGYSWOT = gql`
  mutation deleteStrategyswot($id: String!) {
    deleteStrategyswot(id: $id) {
      id
    }
  }
`;
export const DELETE_STRATEGYMAP = gql`
  mutation deleteStrategymap($id: String!) {
    deleteStrategymap(id: $id) {
      id
    }
  }
`;
export const DELETE_MINUT = gql`
  mutation deleteMinut($id: String!) {
    deleteMinut(id: $id) {
      casetext
    }
  }
`;
export const DELETE_MINUTES = gql`
  mutation deleteMinutes($id: String!) {
    deleteMinutes(id: $id) {
      minutestext
    }
  }
`;
export const LOGIN = gql`
  mutation login($email: String!, $passwordhash: String!) {
    login(email: $email, passwordhash: $passwordhash) {
      value
    }
  }
`;
export const SEND_EMAIL = gql`
  mutation sendEmail($to: String!, $header: String!, $text: String!, $code: String) {
    sendEmail(to: $to, header: $header, text: $text, code: $code) {
      message
    }
  }
`;
export const GET_ACTIVATIONCODE = gql`
  query getActivationcode($email: String!) {
    getActivationcode(email: $email) {
      message
    }
  }
`;
export const DECRYPT_CODE = gql`
  query decryptCode($code: String!) {
    decryptCode(code: $code) {
      message
    }
  }
`;

export const ORGAN_ADDED = gql`
  subscription {
    organAdded {
      ...OrganDetails
    }
  }
  ${ORGAN_DETAILS}
`;
export const LINK_ADDED = gql`
  subscription {
    linkAdded {
      ...LinkDetails
    }
  }
  ${LINK_DETAILS}
`;

export const COMMENT_ADDED = gql`
  subscription {
    commentAdded {
      ...CommentDetails
    }
  }
  ${COMMENT_DETAILS}
`;
export const STRATEGYCOMMENT_ADDED = gql`
  subscription {
    commentAdded {
      ...StrategycommentDetails
    }
  }
  ${STRATEGYCOMMENT_DETAILS}
`;
export const VOTE_ADDED = gql`
  subscription {
    voteAdded {
      ...VoteDetails
    }
  }
  ${VOTING_DETAILS}
`;

export const INITIATIVE_ADDED = gql`
  subscription {
    initiativeAdded {
      ...InitiativeDetails
    }
  }
  ${INITIATIVE_DETAILS}
`;

export const MEETING_ADDED = gql`
  subscription {
    meetingAdded {
      ...MeetingDetails
    }
  }
  ${MEETING_DETAILS}
`;

export const MINUTES_ADDED = gql`
  subscription {
    minutesAdded {
      ...MinutesDetails
    }
  }
  ${MINUTES_DETAILS}
`;
export const USER_ADDED = gql`
  subscription {
    userAdded {
      ...UserDetails
    }
  }
  ${USER_DETAILS}
`;
export const PROPOSAL_ADDED = gql`
  subscription {
    proposalAdded {
      ...ProposalDetails
    }
  }
  ${PROPOSAL_DETAILS}
`;
export const SECTION_ADDED = gql`
  subscription {
    sectionAdded {
      ...SectionDetails
    }
  }
  ${SECTION_DETAILS}
`;
export const MINUTESECTION_ADDED = gql`
  subscription {
    minutesectionAdded {
      ...MinutesectionDetails
    }
  }
  ${MINUTESECTION_DETAILS}
`;
export const MINUT_ADDED = gql`
  subscription {
    minutAdded {
      ...MinutDetails
    }
  }
  ${MINUT_DETAILS}
`;
export const BY_MUNICIPALITY_ORGANS = gql`
  query findOrganByMunicipality($municipalityToSearch: String!) {
    findOrgans(organmunicipality: $municipalityToSearch) {
      organname
      organshort
      organmunicipality
      organurl
      id
    }
  }
`;

export const FIND_USER_BY_ID = gql`
  query findUserByID($id: String!) {
    findUser(id: $id) {
      name
      email
      address
      postnumber
      postoffice
      phone
      activated
      type
      datetime
      acceptedtermsofuse
      gender
      born
      municipality
      role
      secondarymunicipality
      secondarypostnumber
      secondaryaddress
      secondaryrole
      country
      locked
      code
      id
    }
  }
`;
export const FIND_ORGANS_BY_MUNICIPALITY = gql`
  query findOrgansByMunicipality($organmunicipality: String!) {
    findOrgansByMunicipality(organmunicipality: $organmunicipality) {
      organname
      organshort
      organmunicipality
      organurl
      id
    }
  }
`;
export const FIND_MEETINGS_BY_ORGAN = gql`
  query findMeetingsByOrgan($organ: String!) {
    findMeetingsByOrgan(organ: $organ) {
      meetingtext
      meetingdatetime
      organid
      meetingmunicipality
      agendaurl
      id
    }
  }
`;
export const FIND_MEETINGS_BY_MUNICIPALITY = gql`
  query findMeetingsByMunicipality($municipality: String!) {
    findMeetingsByMunicipality(municipality: $municipality) {
      meetingtext
      meetingdatetime
      organid
      meetingmunicipality
      agendaurl
      id
    }
  }
`;
export const FIND_MEETING_BY_ID = gql`
  query findMeetingById($id: String!) {
    findMeetingById(id: $id) {
      meetingtext
      meetingdatetime
      organid
      meetingmunicipality
      agendaurl
      id
    }
  }
`;
export const FIND_SECTIONS_BY_MEETING = gql`
  query findSectionsByMeeting($meeting: String!) {
    findSectionsByMeeting(meeting: $meeting) {
      caseid
      preparer
      header
      casetext
      proposalforadecision
      x
      y
      z
      address
      postnumber
      postoffice
      country
      attachments
      sectionmunicipality
      agendaid
      sectionurl
      id
    }
  }
`;
export const FIND_MINUTESECTIONS_BY_MEETING = gql`
  query findMinutesectionsByMeeting($meeting: String!) {
    findSection(meeting: $meeting) {
      caseid
      preparer
      header
      casetext
      proposalforadecision
      x
      y
      z
      address
      postnumber
      postoffice
      country
      attachments
      sectionmunicipality
      agendaid
      sectionurl
      id
    }
  }
`;
export const FIND_STRATEGYCOMMENT_BY_ID = gql`
  query findStrategyCommentByID($id: String!) {
    findStrategyComment(id: $id) {
      strategydatetime
      strategyclass
      strategytext
      municipality
      userid
      active
      id
    }
  }
`;
export const FIND_STRATEGYCOMMENTS_BY_MUNICIPALITY = gql`
  query findStrategyCommentsByMunicipality($municipality: String!) {
    findStrategyCommentsByMunicipality(municipality: $municipality) {
      strategydatetime
      strategyclass
      strategytext
      municipality
      userid
      active
      id
    }
  }
`;

export const FIND_STRATEGYFOCUSAREA_BY_ID = gql`
  query findStrategyFocusareaByID($id: String!) {
    findStrategyfocusareaByID(id: $id) {
      strategydatetime
      weights
      weightclass
      municipality
      userid
      active
      id
    }
  }
`;
export const FIND_STRATEGYSWOT_BY_ID = gql`
  query findStrategySwotByID($id: String!) {
    findStrategyswotByID(id: $id) {
      strategydatetime
      swotclass
      swottext
      municipality
      userid
      active
      id
    }
  }
`;
export const FIND_STRATEGYBUDGET_BY_ID = gql`
  query findStrategyBudgetByID($id: String!) {
    findStrategyBudgetByID(id: $id) {
      strategydatetime
      target
      municipality
      amount
      userid
      active
      id
    }
  }
`;
export const FIND_STRATEGYMAP_BY_ID = gql`
  query findStrategymapByID($id: String!) {
    findStrategymap(id: $id) {
      strategydatetime
      maptext
      municipality
      x
      y
      userid
      active
      id
    }
  }
`;
export const FIND_STRATEGYFOCUSAREAS_BY_MUNICIPALITY = gql`
  query findStrategyfocusareasByMunicipality($municipality: String!) {
    findStrategyfocusareasByMunicipality(municipality: $municipality) {
      strategydatetime
      weights
      weightclass
      municipality
      userid
      active
      id
    }
  }
`;
export const FIND_STRATEGYSWOTS_BY_MUNICIPALITY = gql`
  query findStrategyswotsByMunicipality($municipality: String!) {
    findStrategyswotsByMunicipality(municipality: $municipality) {
      strategydatetime
      swotclass
      swottext
      municipality
      userid
      active
      id
    }
  }
`;
export const FIND_STRATEGYBUDGETS_BY_MUNICIPALITY = gql`
  query findStrategybudgetByMunicipality($municipality: String!) {
    findStrategybudgetsByMunicipality(municipality: $municipality) {
      strategydatetime
      target
      municipality
      amount
      userid
      active
      id
    }
  }
`;
export const FIND_STRATEGYMAPS_BY_MUNICIPALITY = gql`
  query findStrategymapsByMunicipality($municipality: String!) {
    findStrategymapsByMunicipality(municipality: $municipality) {
      strategydatetime
      maptext
      municipality
      x
      y
      userid
      active
      id
    }
  }
`;
export const FIND_COMMENTS_BY_SECTION = gql`
  query findCommentsBySection($sectionid: String!) {
    findCommentsBySection(sectionid: $sectionid) {
      commentdatetime
      commenttext
      sectionid
      id
    }
  }
`;
export const FIND_PROPOSALS_BY_SECTION = gql`
  query findProposalsBySection($section: String!) {
    findProposalsBySection(sectionid: $section) {
      proposaldatetime
      proposaltext
      sectionid
      userid
      id
    }
  }
`;
export const FIND_LINKS_BY_SECTION = gql`
  query findLinksBySection($section: String!) {
    findLinksBySection(sectionid: $section) {
      linkdatetime
      linktext
      linkdatetime
      linktext
      commentid
      sectionid
      initiativeid
      proposalid
      linktype
      linkref
      userid
      id
    }
  }
`;
export const FIND_VOTES_BY_SECTION = gql`
  query findVotesBySection($section: String!) {
    findVotesBySection(section: $section) {
      proposalid
      commentid
      sectionid
      initiativeid
      linkid
      userid
      votedatetime
      voteinfo
      id
    }
  }
`;
export const FIND_VOTES_BY_MUNICIPALITY = gql`
  query findVotesByMunicipality($municipality: String!) {
    findVotesByMunicipality(municipality: $municipality) {
      proposalid
      commentid
      sectionid
      initiativeid
      strategycommentid
      strategyswotid
      strategybudgetid
      strategyfocusareaid
      strategymapid
      linkid
      userid
      votedatetime
      voteinfo
      municipality
      id
    }
  }
`;
export const FIND_INITIATIVES_BY_MUNICIPALITY = gql`
  query findInitiativesByMunicipality($municipality: String!) {
    findInitiativesByMunicipality(municipality: $municipality) {
      organid
      initiativetext
      initiativedatetime
      initiativeinfo
      initiativeaccepted
      active
      userid
      id
    }
  }
`;
